/* Dubailist "Next Gen" layer: search overlay, multi-level menu, mega menu,
   tab bar, recently viewed, delivery ETA, motion polish. No dependencies.
   Everything degrades to plain links/forms without JS. */
(() => {
  'use strict';
  const T = window.theme || { routes: {}, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const open = (id, opener) => window.DL && window.DL.openDrawer(id, opener);

  /* =============== drawers live at <body> level =============== */
  // The header hides on scroll with a CSS transform. A transformed ancestor turns position:fixed
  // into position:absolute, which made the quick-add sheet render inside the hidden header
  // (the "stuck at the top" glitch on collection pages). Moving the drawers to <body> fixes it.
  const hoistDrawers = () => $$('.header-section .drawer, .shopify-section .drawer').forEach((d) => {
    if (d.parentElement === document.body || d.id === 'CartDrawer') return;
    const old = document.body.querySelector(':scope > #' + d.id); if (old && old !== d) old.remove();
    document.body.appendChild(d);
  });
  hoistDrawers();
  document.addEventListener('shopify:section:load', hoistDrawers);

  /* =============== search pill: rotating hints =============== */
  $$('[data-rotator]').forEach((rot) => {
    const words = $$('.search-pill__word', rot); if (words.length < 2 || reduce) return;
    let i = 0;
    setInterval(() => {
      if (document.hidden) return;
      const cur = words[i]; i = (i + 1) % words.length; const nxt = words[i];
      cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      nxt.classList.remove('is-leaving'); nxt.classList.add('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 600);
    }, 2600);
  });
  // one-time glow ring on the search pill to draw the eye (first visit of the session)
  const pill = $('.search-pill');
  if (pill && !reduce && !sessionStorage.getItem('dl_pill')) {
    setTimeout(() => { pill.classList.add('is-idle-glow'); setTimeout(() => pill.classList.remove('is-idle-glow'), 4200); }, 1800);
    try { sessionStorage.setItem('dl_pill', '1'); } catch (e) { /* ignore */ }
  }
  // "/" opens search on desktop
  document.addEventListener('keydown', (e) => {
    if (e.key !== '/' || e.metaKey || e.ctrlKey || /input|textarea|select/i.test(document.activeElement.tagName) || document.activeElement.isContentEditable) return;
    if (!$('#SearchDrawer')) return;
    e.preventDefault(); open('SearchDrawer', pill);
  });

  /* =============== search overlay =============== */
  const sx = $('[data-sx]');
  if (sx) {
    const drawer = sx.closest('.drawer');
    const input = $('#SearchInput', sx);
    const results = $('[data-sx-results]', sx);
    const skeleton = $('[data-sx-skeleton]', sx);
    const status = $('[data-sx-status]', sx);
    const clearBtn = $('[data-sx-clear]', sx);
    const micBtn = $('[data-sx-mic]', sx);
    const RKEY = 'dl_recent_searches', VKEY = 'dl_recent_viewed';
    let ctrl, lastQ = '', cache = new Map();

    const renderRecent = () => {
      const list = store.get(RKEY, []); const wrap = $('[data-sx-recent-wrap]', sx); const box = $('[data-sx-recent]', sx);
      if (!wrap || !box) return;
      wrap.hidden = !list.length;
      box.innerHTML = list.map((q, i) => `<span class="sx-chip" style="--i:${i}"><a href="${T.routes.search}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last" data-sx-term="${esc(q)}" style="text-decoration:none">${esc(q)}</a><button type="button" class="sx-chip__x" data-sx-remove="${esc(q)}" aria-label="Remove ${esc(q)}"><svg class="icon icon-xs" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></span>`).join('');
    };
    const saveRecent = (q) => {
      q = (q || '').trim(); if (q.length < 2) return;
      const list = store.get(RKEY, []).filter((x) => x.toLowerCase() !== q.toLowerCase());
      list.unshift(q); store.set(RKEY, list.slice(0, 8));
    };
    const renderViewed = () => {
      const list = store.get(VKEY, []).filter((p) => p && p.u && p.u !== location.pathname).slice(0, 6);
      const wrap = $('[data-sx-viewed-wrap]', sx), box = $('[data-sx-viewed]', sx);
      if (!wrap || !box) return;
      wrap.hidden = !list.length;
      box.innerHTML = list.map((p, i) => `<a class="sx-prod" href="${esc(p.u)}" style="--i:${i}"><span class="sx-prod__img">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy" width="150" height="150">` : ''}${p.d ? `<span class="sx-prod__badge">-${esc(p.d)}%</span>` : ''}</span>${p.v ? `<span class="sx-prod__vendor">${esc(p.v)}</span>` : ''}<span class="sx-prod__title">${esc(p.t)}</span><span class="sx-prod__price"><b>${esc(p.p)}</b>${p.c ? ` <s>${esc(p.c)}</s>` : ''}</span></a>`).join('');
    };

    const highlight = (root, q) => {
      const words = q.toLowerCase().split(/\s+/).filter((w) => w.length > 1).map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (!words.length) return;
      const re = new RegExp('(' + words.join('|') + ')', 'ig');
      $$('[data-hl]', root).forEach((el) => { el.innerHTML = esc(el.textContent).replace(re, '<mark class="sx-hl">$1</mark>'); });
    };

    const setState = (state) => {
      sx.classList.toggle('sx--has-results', state === 'results');
      sx.classList.toggle('sx--no-results', state === 'none');
      results.hidden = state === 'empty';
      input.setAttribute('aria-expanded', String(state === 'results'));
    };

    const show = (html, q) => {
      sx.classList.remove('is-loading'); skeleton.hidden = true;
      const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-content]');
      if (!node) { setState('empty'); return; }
      results.innerHTML = node.innerHTML;
      highlight(results, q);
      const n = parseInt(node.getAttribute('data-count'), 10) || 0;
      const none = !!$('.sx-none', results);
      setState(none ? 'none' : 'results');
      if (status) status.textContent = none ? '' : `${n} ${n === 1 ? 'product' : 'products'} found`;
      results.classList.remove('sx-in'); void results.offsetWidth; results.classList.add('sx-in');
    };

    const run = async () => {
      const q = input.value.trim();
      clearBtn.hidden = !q;
      if (q === lastQ) return; lastQ = q;
      if (q.length < 2) { if (ctrl) ctrl.abort(); sx.classList.remove('is-loading'); skeleton.hidden = true; setState('empty'); results.innerHTML = ''; return; }
      if (cache.has(q)) { show(cache.get(q), q); return; }
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      sx.classList.add('is-loading');
      if (results.hidden || !results.innerHTML) skeleton.hidden = false;
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
        const res = await fetch(url, { signal: ctrl.signal });
        const html = await res.text();
        cache.set(q, html);
        if (input.value.trim() === q) show(html, q);
      } catch (err) { if (err.name !== 'AbortError') { sx.classList.remove('is-loading'); skeleton.hidden = true; } }
    };
    let t; const debounced = () => { clearTimeout(t); t = setTimeout(run, 170); };
    input.addEventListener('input', () => { clearBtn.hidden = !input.value; debounced(); });

    clearBtn.addEventListener('click', () => { input.value = ''; run(); input.focus(); });

    // keyboard: arrows move through options (suggestions, chips, products)
    input.addEventListener('keydown', (e) => {
      const opts = $$('[role="option"]', results).filter((o) => o.offsetParent !== null);
      if (!opts.length || results.hidden) return;
      let i = opts.findIndex((o) => o.getAttribute('aria-selected') === 'true');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        i = e.key === 'ArrowDown' ? (i + 1) % opts.length : (i - 1 + opts.length) % opts.length;
        opts.forEach((o, j) => o.setAttribute('aria-selected', String(j === i)));
        if (opts[i].id) input.setAttribute('aria-activedescendant', opts[i].id);
        opts[i].scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      } else if (e.key === 'Enter' && i > -1) { e.preventDefault(); saveRecent(input.value); opts[i].click(); }
    });

    $('[data-sx-form]', sx).addEventListener('submit', (e) => {
      if (input.value.trim().length < 1) { e.preventDefault(); input.focus(); return; }
      saveRecent(input.value);
    });

    sx.addEventListener('click', (e) => {
      const fill = e.target.closest('[data-sx-fill]');
      if (fill) { e.preventDefault(); input.value = fill.getAttribute('data-sx-fill') + ' '; input.focus(); run(); return; }
      const rm = e.target.closest('[data-sx-remove]');
      if (rm) { e.preventDefault(); const q = rm.getAttribute('data-sx-remove'); store.set(RKEY, store.get(RKEY, []).filter((x) => x !== q)); renderRecent(); return; }
      if (e.target.closest('[data-sx-recent-clear]')) { store.set(RKEY, []); renderRecent(); return; }
      const term = e.target.closest('[data-sx-term]');
      if (term) saveRecent(term.getAttribute('data-sx-term'));
      else if (e.target.closest('.sx-prod, .sx-chip--col') && input.value.trim()) saveRecent(input.value);
    });

    // voice search (where supported)
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SR && micBtn) {
      micBtn.hidden = false;
      let rec = null;
      micBtn.addEventListener('click', () => {
        if (rec) { rec.stop(); return; }
        rec = new SR(); rec.lang = document.documentElement.lang === 'ar' ? 'ar-AE' : 'en-AE'; rec.interimResults = true; rec.maxAlternatives = 1;
        micBtn.classList.add('is-listening'); input.placeholder = (T.strings && T.strings.listening) || 'Listening…';
        rec.onresult = (ev) => { input.value = Array.from(ev.results).map((r) => r[0].transcript).join(''); clearBtn.hidden = !input.value; debounced(); };
        rec.onend = rec.onerror = () => { micBtn.classList.remove('is-listening'); input.placeholder = input.getAttribute('data-ph') || ''; rec = null; };
        input.setAttribute('data-ph', input.getAttribute('data-ph') || input.placeholder);
        rec.start();
      });
    }

    document.addEventListener('drawer:open', (e) => {
      if (e.detail.id !== 'SearchDrawer') return;
      renderRecent(); renderViewed();
      // Lazy images inside the overlay start loading only once it is opened.
      $$('img[loading="lazy"]', sx).forEach((img) => { img.loading = 'eager'; });
      requestAnimationFrame(() => { input.focus({ preventScroll: true }); if (input.value) input.select(); });
    });
    document.addEventListener('drawer:close', (e) => { if (e.detail.id === 'SearchDrawer') $$('[aria-selected="true"]', results).forEach((o) => o.setAttribute('aria-selected', 'false')); });
    if (drawer && input.value && document.body.classList.contains('template-search')) lastQ = '';
  }


  /* inline search boxes (search page, 404) hand over to the overlay */
  $$('[data-predictive] input[type="search"]').forEach((inp) => {
    const go = (e) => {
      const si = $('#SearchInput'); if (!si || !window.DL) return;
      if (e) e.preventDefault();
      si.value = inp.value; window.DL.openDrawer('SearchDrawer', inp);
      si.dispatchEvent(new Event('input'));
    };
    inp.addEventListener('pointerdown', go); inp.addEventListener('keydown', (e) => { if (e.key.length === 1 || e.key === 'Backspace') { setTimeout(() => go(), 0); } });
  });

  /* =============== mobile menu: sliding panels =============== */
  const menu = $('[data-menu]');
  if (menu) {
    const panels = $$('[data-menu-panel]', menu);
    const stack = [];
    const stagger = (panel) => $$('.mi', panel).forEach((el, n) => el.style.setProperty('--mi', Math.min(n, 14)));
    const activate = (panel, back) => {
      const cur = $('.menu-ng__panel.is-active', menu);
      if (cur === panel) return;
      if (cur) {
        cur.classList.remove('is-active'); cur.setAttribute('aria-hidden', 'true'); cur.inert = true;
        if (!back) cur.classList.add('is-behind');
      }
      panel.classList.remove('is-behind'); panel.classList.add('is-active'); panel.removeAttribute('aria-hidden'); panel.inert = false;
      panel.scrollTop = 0; stagger(panel);
      setTimeout(() => { const f = $('.menu-ng__back, a, button', panel); if (f) f.focus({ preventScroll: true }); }, 60);
    };
    menu.addEventListener('click', (e) => {
      const go = e.target.closest('[data-menu-go]');
      if (go) { e.preventDefault(); const p = $(`[data-menu-panel="${go.getAttribute('data-menu-go')}"]`, menu); if (p) { stack.push($('.menu-ng__panel.is-active', menu)); go.setAttribute('aria-expanded', 'true'); activate(p, false); } return; }
      if (e.target.closest('[data-menu-back]')) {
        e.preventDefault();
        const prev = stack.pop() || panels[0];
        const cur = $('.menu-ng__panel.is-active', menu);
        prev.classList.remove('is-behind'); activate(prev, true);
        const opener = $(`[data-menu-go="${cur.getAttribute('data-menu-panel')}"]`, menu);
        if (opener) { opener.setAttribute('aria-expanded', 'false'); setTimeout(() => opener.focus({ preventScroll: true }), 70); }
      }
    });
    // swipe right-to-left on a sub panel goes back (and left-swipe on root closes)
    let sx0 = null, sy0 = 0;
    menu.addEventListener('touchstart', (e) => { sx0 = e.touches[0].clientX; sy0 = e.touches[0].clientY; }, { passive: true });
    menu.addEventListener('touchend', (e) => {
      if (sx0 === null) return; const dx = e.changedTouches[0].clientX - sx0, dy = e.changedTouches[0].clientY - sy0; sx0 = null;
      if (Math.abs(dx) < 70 || Math.abs(dy) > 50) return;
      const rtl = document.dir === 'rtl'; const cur = $('.menu-ng__panel.is-active', menu);
      if ((dx > 0 && !rtl) || (dx < 0 && rtl)) { const b = $('[data-menu-back]', cur); if (b) b.click(); }
      else if (cur === panels[0] && window.DL) window.DL.closeDrawer('MenuDrawer');
    }, { passive: true });
    document.addEventListener('drawer:open', (e) => { if (e.detail.id === 'MenuDrawer') stagger($('.menu-ng__panel.is-active', menu)); });
    document.addEventListener('drawer:close', (e) => {
      if (e.detail.id !== 'MenuDrawer') return;
      setTimeout(() => {
        panels.forEach((p, n) => { p.classList.toggle('is-active', n === 0); p.classList.remove('is-behind'); if (n) { p.setAttribute('aria-hidden', 'true'); p.inert = true; } else { p.removeAttribute('aria-hidden'); p.inert = false; } });
        $$('[data-menu-go]', menu).forEach((b) => b.setAttribute('aria-expanded', 'false')); stack.length = 0;
      }, 520);
    });
  }

  /* =============== desktop mega menu + sliding indicator =============== */
  const nav = $('[data-mega-nav]');
  if (nav) {
    const wrap = nav.closest('[data-header]');
    const ind = $('[data-nav-indicator]', nav);
    const items = $$('[data-mega-item]', nav);
    let openItem = null, tOpen, tClose;
    const moveInd = (link) => {
      if (!ind || !link) return;
      const r = link.getBoundingClientRect(), w = wrap.getBoundingClientRect();
      const left = document.dir === 'rtl' ? -(w.right - r.right) : r.left - w.left;
      ind.style.setProperty('--x', (left + 10) + 'px'); ind.style.setProperty('--w', Math.max(0, r.width - 20) + 'px');
      nav.classList.add('has-indicator');
    };
    const resetInd = () => { const cur = $('.nav-ng__link[aria-current="page"]', nav); if (cur) moveInd(cur); else nav.classList.remove('has-indicator'); };
    const setOpen = (item) => {
      if (openItem === item) return;
      if (openItem) { openItem.classList.remove('is-open'); const b = $('.nav-ng__toggle', openItem); if (b) b.setAttribute('aria-expanded', 'false'); }
      openItem = item;
      if (item) { item.classList.add('is-open'); const b = $('.nav-ng__toggle', item); if (b) b.setAttribute('aria-expanded', 'true'); $$('img[loading="lazy"]', item).forEach((i) => { i.loading = 'eager'; }); }
      document.documentElement.classList.toggle('mega-open', !!item);
    };
    items.forEach((item) => {
      const link = $('.nav-ng__link', item), toggle = $('.nav-ng__toggle', item);
      item.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'touch') return;
        clearTimeout(tClose); moveInd(link);
        clearTimeout(tOpen); tOpen = setTimeout(() => setOpen(item.classList.contains('has-mega') ? item : null), openItem ? 0 : 110);
      });
      item.addEventListener('pointerleave', (e) => { if (e.pointerType === 'touch') return; clearTimeout(tOpen); });
      link.addEventListener('focus', () => moveInd(link));
      if (toggle) toggle.addEventListener('click', () => { setOpen(openItem === item ? null : item); if (openItem) { const f = $('.mega-ng a', item); if (f) f.focus(); } });
    });
    wrap.addEventListener('pointerleave', (e) => { if (e.pointerType === 'touch') return; clearTimeout(tOpen); tClose = setTimeout(() => { setOpen(null); resetInd(); }, 180); });
    wrap.addEventListener('pointerenter', () => clearTimeout(tClose));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openItem) { const b = $('.nav-ng__toggle', openItem); setOpen(null); if (b) b.focus(); } });
    document.addEventListener('focusin', (e) => { if (openItem && !openItem.contains(e.target)) setOpen(null); });
    const scrim = $('[data-mega-scrim]'); if (scrim) scrim.addEventListener('click', () => setOpen(null));
    window.addEventListener('resize', () => { setOpen(null); resetInd(); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(resetInd); else resetInd();
  }

  /* =============== tab bar: tuck away while scrolling down a long page =============== */
  const tabbar = $('[data-tabbar]');
  if (tabbar && !reduce) {
    let lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => { const y = window.scrollY; const down = y > lastY + 6 && y > 400; const up = y < lastY - 6; if (down) tabbar.classList.add('is-tucked'); else if (up || y < 200) tabbar.classList.remove('is-tucked'); lastY = y; ticking = false; });
    }, { passive: true });
  }


  /* =============== smooth scroll to reviews from the star rating =============== */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-scroll-to]'); if (!a) return;
    const t = document.querySelector(a.getAttribute('href')); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', a.getAttribute('href'));
  });

  /* =============== recently viewed rail (product pages) =============== */
  $$('[data-recently-viewed]').forEach((sec) => {
    const limit = parseInt(sec.getAttribute('data-limit'), 10) || 8;
    const list = store.get('dl_recent_viewed', []).filter((p) => p && p.u && p.u !== location.pathname).slice(0, limit);
    if (list.length < 2) return;
    $('[data-rv-rail]', sec).innerHTML = list.map((p) => `<a class="sx-prod" href="${esc(p.u)}"><span class="sx-prod__img">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy" width="150" height="150">` : ''}${p.d ? `<span class="sx-prod__badge">-${esc(p.d)}%</span>` : ''}</span>${p.v ? `<span class="sx-prod__vendor">${esc(p.v)}</span>` : ''}<span class="sx-prod__title">${esc(p.t)}</span><span class="sx-prod__price"><b>${esc(p.p)}</b>${p.c ? ` <s>${esc(p.c)}</s>` : ''}</span></a>`).join('');
    sec.hidden = false;
  });

  /* =============== recently viewed (written on product pages) =============== */
  const pv = $('#ViewedProduct');
  if (pv) {
    try {
      const p = JSON.parse(pv.textContent);
      const list = store.get('dl_recent_viewed', []).filter((x) => x && x.u !== p.u);
      list.unshift(p); store.set('dl_recent_viewed', list.slice(0, 12));
    } catch (e) { /* ignore */ }
  }

  /* =============== delivery ETA + cut-off countdown (UAE) =============== */
  $$('[data-eta]').forEach((el) => {
    const cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 17;
    const minD = parseInt(el.getAttribute('data-min'), 10) || 3, maxD = parseInt(el.getAttribute('data-max'), 10) || 5;
    const tz = el.getAttribute('data-tz') || 'Asia/Dubai';
    const locale = document.documentElement.lang || 'en';
    const partsNow = () => {
      const f = new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, weekday: 'short' });
      const o = {}; f.formatToParts(new Date()).forEach((p) => { o[p.type] = p.value; }); return o;
    };
    const closedAttr = el.getAttribute('data-closed');
    const closed = (closedAttr === null ? '6,0' : closedAttr).split(',').filter((x) => x !== '').map(Number); // days with no processing/delivery (0 = Sun)
    const isWeekend = (d) => closed.includes(d.getUTCDay());
    const addBiz = (d, n) => { const x = new Date(d); let k = 0; while (k < n) { x.setUTCDate(x.getUTCDate() + 1); if (!isWeekend(x)) k++; } return x; };
    const fmt = (d) => d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    const left = $('[data-cutoff-left]', el), next = $('[data-eta-next]', el), today = $('[data-eta-today]', el), range = $('[data-eta-range]', el);
    const tick = () => {
      const o = partsNow();
      const base = new Date(Date.UTC(+o.year, +o.month - 1, +o.day));
      const mins = (+o.hour % 24) * 60 + (+o.minute);
      const before = !isWeekend(base) && mins < cutoff * 60;
      let start = base; if (!before) { start = addBiz(base, 1); }
      const a = addBiz(start, minD), b = addBiz(start, maxD);
      if (range) range.textContent = `${fmt(a)} – ${fmt(b)}`;
      if (today && next) { today.hidden = !before; next.hidden = before; }
      if (before && left) { const m = cutoff * 60 - mins; left.textContent = `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m`; }
      el.hidden = false;
    };
    tick(); setInterval(tick, 30000);
  });


  /* =============== Tabby + Tamara instalments (product page) =============== */
  const bnpl = $('[data-bnpl]');
  if (bnpl) {
    const cur = bnpl.getAttribute('data-currency'); const dec = parseInt(bnpl.getAttribute('data-decimals'), 10) || 2;
    const lang = bnpl.getAttribute('data-lang') === 'ar' ? 'ar' : 'en';
    let amount = parseFloat(bnpl.getAttribute('data-amount')) || 0;
    const tabbyKey = bnpl.getAttribute('data-tabby-key'), tamaraKey = bnpl.getAttribute('data-tamara-key');
    const loadScript = (src) => new Promise((res, rej) => { const s = document.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
    const renderTabby = () => {
      if (!tabbyKey || !window.TabbyPromo) return;
      const slot = $('[data-bnpl-tabby]', bnpl); if (!slot) return; slot.innerHTML = '';
      const code = bnpl.getAttribute('data-tabby-merchant') || (cur === 'AED' ? 'default' : cur === 'SAR' ? 'ksa' : cur === 'KWD' ? 'KW' : undefined);
      const cfg = { selector: '#TabbyPromo', currency: cur, price: amount.toFixed(dec), lang, source: 'product', shouldInheritBg: false, publicKey: tabbyKey };
      if (code) cfg.merchantCode = code;
      try { new window.TabbyPromo(cfg); } catch (e) { /* widget unavailable */ }
    };
    const renderTamara = () => {
      if (!tamaraKey) return;
      const slot = $('[data-bnpl-tamara-slot]', bnpl); if (!slot) return;
      let w = $('tamara-widget', slot);
      if (!w) { w = document.createElement('tamara-widget'); w.setAttribute('type', 'tamara-summary'); w.setAttribute('inline-type', '2'); w.setAttribute('config', JSON.stringify({ badgePosition: 'right', showExtraContent: '' })); slot.appendChild(w); }
      w.setAttribute('amount', amount.toFixed(dec));
      if (window.TamaraWidgetV2 && typeof window.TamaraWidgetV2.refresh === 'function') { try { window.TamaraWidgetV2.refresh(); } catch (e) { /* ignore */ } }
    };
    const start = () => {
      if (tabbyKey) loadScript('https://checkout.tabby.ai/tabby-promo.js').then(renderTabby).catch(() => { const r = $('.bnpl__row--tabby', bnpl); if (r) r.remove(); });
      if (tamaraKey) {
        window.tamaraWidgetConfig = { lang, country: bnpl.getAttribute('data-tamara-country') || 'AE', publicKey: tamaraKey, css: ':host{--font-primary:inherit!important;--font-secondary:inherit!important}.tamara-summary-widget__amount{font-weight:700!important}', style: { fontSize: '13px', badgeRatio: 1.1 } };
        renderTamara();
        loadScript('https://cdn.tamara.co/widget-v2/tamara-widget.js').catch(() => { const r = $('.bnpl__row--tamara', bnpl); if (r) r.remove(); });
      }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((ents) => { if (ents.some((e) => e.isIntersecting)) { io.disconnect(); start(); } }, { rootMargin: '300px 0px' });
      io.observe(bnpl);
    } else start();
    document.addEventListener('variant:change', (e) => {
      const v = e.detail && e.detail.variant; if (!v || !e.target.closest || !e.target.closest('[data-main-product]')) return;
      const next = v.price / 100; if (next === amount) return; amount = next;
      renderTabby(); renderTamara();
    });
  }


  /* =============== Shop by price: peek into each price window =============== */
  // The store has no price filter, so we read the catalogue cheapest-first (compact JSON, 250 per page)
  // and work out a real in-stock count + photos from each window's own price range.
  const pwTrack = $('.pw__track');
  if (pwTrack) {
    const many = pwTrack.getAttribute('data-items-tpl') || '99999 items', one = pwTrack.getAttribute('data-item-tpl') || '1 item';
    const cards = $$('[data-band-max]', pwTrack).map((el) => ({ el, cap: (parseFloat(el.getAttribute('data-band-max')) || 0) * 100 })).sort((a, b) => a.cap - b.cap);
    const topCap = cards.length ? cards[cards.length - 1].cap : 0;
    const run = async () => {
      const items = []; let complete = false;
      for (let page = 1; page <= 3; page++) {
        try {
          const html = await (await fetch(pwTrack.getAttribute('data-peek-url') + '&page=' + page)).text();
          const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-band-peek-out]'); if (!node) break;
          const rows = JSON.parse(node.textContent || '[]'); items.push(...rows);
          const pages = parseInt(node.getAttribute('data-pages'), 10) || 1;
          if (!rows.length || rows[rows.length - 1][3] > topCap || page >= pages) { complete = true; break; }
        } catch (e) { break; }
      }
      const lastPrice = items.length ? items[items.length - 1][3] : 0;
      let prev = 0;
      cards.forEach(({ el, cap }) => {
        const inStock = items.filter((r) => r[1] === 1 && r[0] > 0 && r[0] <= cap);
        const exact = complete || lastPrice > cap;
        const n = exact ? inStock.length : Math.floor(inStock.length / 100) * 100;
        const c = $('[data-band-count]', el);
        if (c && n > 0) { c.textContent = n === 1 && exact ? one : many.replace('99999', n.toLocaleString() + (exact ? '' : '+')); c.classList.add('is-ready'); }
        // photos from this window's own range first (so every window looks different), then anything under the cap
        let pick = inStock.filter((r) => r[0] > prev && r[2]); if (pick.length < 3) pick = pick.concat(inStock.filter((r) => r[0] <= prev && r[2]).reverse());
        const step = Math.max(1, Math.floor(pick.length / 3));
        const chosen = [0, 1, 2].map((i) => pick[Math.min(i * step, pick.length - 1)]).filter((r, i, arr) => r && arr.indexOf(r) === i);
        const box = $('[data-band-imgs]', el);
        if (box) {
          if (chosen.length) { box.innerHTML = ''; chosen.forEach((r) => { const im = new Image(120, 120); im.alt = ''; im.decoding = 'async'; im.src = r[2]; box.appendChild(im); }); } else box.remove();
        }
        prev = cap;
      });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((ents) => { if (ents.some((e) => e.isIntersecting)) { io.disconnect(); run(); } }, { rootMargin: '400px 0px' });
      io.observe(pwTrack);
    } else run();
  }

  /* =============== brand rails (e.g. Guess): load in-stock cards from the brand page when near =============== */
  const brandRails = $$('[data-brand-rail][data-url]');
  if (brandRails.length) {
    const fill = async (rail) => {
      try {
        const html = await (await fetch(rail.getAttribute('data-url'))).text();
        const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-brand-items]');
        const limit = parseInt(rail.getAttribute('data-limit'), 10) || 10;
        const cards = box ? Array.from(box.children).slice(0, limit) : [];
        if (!cards.length) { rail.closest('section').hidden = true; return; }
        rail.replaceChildren(...cards.map((c) => document.importNode(c, true)));
        if (window.DL && window.DL.initReveal) window.DL.initReveal(rail);
        rail.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed'));
        rail.querySelectorAll('img.card__img-1').forEach((img) => { const on = () => img.classList.add('is-loaded'); if (img.complete && img.naturalWidth) on(); else { img.addEventListener('load', on, { once: true }); img.addEventListener('error', on, { once: true }); } });
      } catch (e) { rail.closest('section').hidden = true; }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { io.unobserve(en.target); fill(en.target); } }), { rootMargin: '600px 0px' });
      brandRails.forEach((r) => io.observe(r));
    } else brandRails.forEach(fill);
  }

  /* =============== product image zoom: desktop hover magnifier + full-screen viewer (pinch / double-tap / pan / swipe) =============== */
  const zGallery = $('[data-main-product] .gallery') || $('.gallery');
  const zImgs = zGallery ? $$('.gallery__slide img[data-zoom]', zGallery) : [];
  if (zImgs.length) {
    const zBtn = $('[data-zoom-open]', zGallery);
    const T = (k, d) => (zBtn && zBtn.getAttribute('data-t-' + k)) || d;
    const srcs = zImgs.map((im) => im.getAttribute('data-zoom'));
    const alts = zImgs.map((im) => im.getAttribute('alt') || '');
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

    // desktop: in-place magnifier that follows the cursor
    if (fine && !reduce) {
      zImgs.forEach((img) => {
        const slide = img.closest('.gallery__slide');
        slide.classList.add('can-zoom');
        let hi = false;
        slide.addEventListener('pointerenter', () => {
          if (!hi) { hi = true; const pre = new Image(); pre.onload = () => { img.removeAttribute('srcset'); img.src = pre.src; }; pre.src = img.getAttribute('data-zoom'); }
          slide.classList.add('is-zooming');
        });
        slide.addEventListener('pointermove', (e) => {
          const r = slide.getBoundingClientRect();
          img.style.transformOrigin = `${clamp((e.clientX - r.left) / r.width * 100, 0, 100)}% ${clamp((e.clientY - r.top) / r.height * 100, 0, 100)}%`;
        });
        slide.addEventListener('pointerleave', () => slide.classList.remove('is-zooming'));
      });
    }

    // full-screen viewer
    let lb = null, idx = 0, st = { s: 1, x: 0, y: 0 };
    const build = () => {
      lb = document.createElement('dialog');
      lb.className = 'zoomlb';
      lb.setAttribute('aria-label', T('label', 'Image viewer'));
      lb.innerHTML = `<div class="zoomlb__bar"><span class="zoomlb__count" aria-live="polite"></span><button type="button" class="zoomlb__btn" data-zl-close aria-label="${T('close', 'Close')}"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>
        <div class="zoomlb__stage"><div class="zoomlb__track">${srcs.map((u, i) => `<div class="zoomlb__slide"><img src="${i === 0 ? u : ''}" data-src="${u}" alt="${alts[i].replace(/"/g, '&quot;')}" draggable="false"></div>`).join('')}</div>
        ${srcs.length > 1 ? `<button type="button" class="zoomlb__btn zoomlb__nav zoomlb__nav--prev" data-zl-prev aria-label="${T('prev', 'Previous image')}"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="m15 6-6 6 6 6"/></svg></button><button type="button" class="zoomlb__btn zoomlb__nav zoomlb__nav--next" data-zl-next aria-label="${T('next', 'Next image')}"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg></button>` : ''}</div>
        ${srcs.length > 1 ? `<div class="zoomlb__thumbs">${srcs.map((u, i) => `<button type="button" data-zl-go="${i}" aria-label="${i + 1}"><img src="${u.replace(/width=\d+/, 'width=160')}" alt="" loading="lazy"></button>`).join('')}</div>` : ''}`;
      document.body.appendChild(lb);
      const track = $('.zoomlb__track', lb), stage = $('.zoomlb__stage', lb);
      const curImg = () => $$('.zoomlb__slide img', lb)[idx];
      const apply = (anim) => { const im = curImg(); if (!im) return; im.style.transition = anim ? 'transform 260ms cubic-bezier(.2,.8,.2,1)' : 'none'; im.style.transform = `translate(${st.x}px, ${st.y}px) scale(${st.s})`; lb.classList.toggle('is-zoomed', st.s > 1.01); };
      const bound = () => { const r = stage.getBoundingClientRect(); const mx = (r.width * (st.s - 1)) / 2, my = (r.height * (st.s - 1)) / 2; st.x = clamp(st.x, -mx, mx); st.y = clamp(st.y, -my, my); };
      const reset = (anim) => { st = { s: 1, x: 0, y: 0 }; apply(anim); };
      const zoomAt = (s, cx, cy, anim) => { const r = stage.getBoundingClientRect(); const ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2); const k = s / st.s; st.x = ox - (ox - st.x) * k; st.y = oy - (oy - st.y) * k; st.s = s; bound(); apply(anim); };
      const go = (i, anim = true) => {
        reset(false);
        idx = (i + srcs.length) % srcs.length;
        const im = curImg(); if (im && !im.getAttribute('src')) im.src = im.getAttribute('data-src');
        [idx + 1, idx - 1].forEach((j) => { const n = $$('.zoomlb__slide img', lb)[(j + srcs.length) % srcs.length]; if (n && !n.getAttribute('src')) n.src = n.getAttribute('data-src'); });
        track.style.transition = anim && !reduce ? 'transform 380ms cubic-bezier(.2,.8,.2,1)' : 'none';
        track.style.transform = `translateX(${-idx * 100}%)`;
        $('.zoomlb__count', lb).textContent = srcs.length > 1 ? `${idx + 1} / ${srcs.length}` : '';
        $$('[data-zl-go]', lb).forEach((b, j) => b.setAttribute('aria-current', String(j === idx)));
      };
      lb._go = go;
      lb.addEventListener('click', (e) => {
        if (e.target.closest('[data-zl-close]')) { lb.close(); return; }
        if (e.target.closest('[data-zl-prev]')) { go(idx - 1); return; }
        if (e.target.closest('[data-zl-next]')) { go(idx + 1); return; }
        const t = e.target.closest('[data-zl-go]'); if (t) go(+t.getAttribute('data-zl-go'));
      });
      lb.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') go(idx + 1); if (e.key === 'ArrowLeft') go(idx - 1); });
      lb.addEventListener('close', () => { document.documentElement.classList.remove('zoomlb-open'); reset(false); });
      // gestures
      const pts = new Map(); let g0 = null, lastTap = 0, moved = 0;
      stage.addEventListener('wheel', (e) => { e.preventDefault(); zoomAt(clamp(st.s * (e.deltaY < 0 ? 1.15 : 0.87), 1, 4), e.clientX, e.clientY, false); if (st.s <= 1.01) reset(false); }, { passive: false });
      stage.addEventListener('pointerdown', (e) => {
        if (e.target.closest('button')) return;
        stage.setPointerCapture(e.pointerId); pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        moved = 0;
        const a = [...pts.values()];
        if (a.length === 2) g0 = { d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y), s: st.s, mx: (a[0].x + a[1].x) / 2, my: (a[0].y + a[1].y) / 2 };
        else g0 = { x: e.clientX, y: e.clientY, sx: st.x, sy: st.y, t: Date.now() };
      });
      stage.addEventListener('pointermove', (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const a = [...pts.values()];
        if (a.length === 2 && g0 && g0.d) {
          const d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
          zoomAt(clamp(g0.s * d / g0.d, 1, 4), (a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2, false); moved = 99; return;
        }
        if (!g0 || g0.d) return;
        const dx = e.clientX - g0.x, dy = e.clientY - g0.y; moved = Math.max(moved, Math.abs(dx) + Math.abs(dy));
        if (st.s > 1.01) { st.x = g0.sx + dx; st.y = g0.sy + dy; bound(); apply(false); }
        else if (Math.abs(dx) > Math.abs(dy)) { track.style.transition = 'none'; track.style.transform = `translateX(calc(${-idx * 100}% + ${dx}px))`; }
        else if (dy > 0) { const im = curImg(); if (im) { im.style.transition = 'none'; im.style.transform = `translateY(${dy}px) scale(${1 - Math.min(dy, 300) / 1500})`; } lb.style.setProperty('--zl-fade', String(1 - Math.min(dy, 300) / 400)); }
      });
      const end = (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.delete(e.pointerId);
        if (pts.size) { const p = [...pts.values()][0]; g0 = { x: p.x, y: p.y, sx: st.x, sy: st.y, t: Date.now() }; return; }
        const dx = e.clientX - (g0 ? g0.x : e.clientX), dy = e.clientY - (g0 ? g0.y : e.clientY);
        lb.style.removeProperty('--zl-fade');
        if (moved < 10) {
          const now = Date.now();
          if (e.pointerType === 'mouse' || now - lastTap < 300) { if (st.s > 1.01) reset(true); else zoomAt(2.5, e.clientX, e.clientY, true); lastTap = 0; }
          else lastTap = now;
        } else if (st.s <= 1.01 && g0 && !g0.d) {
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 60) go(idx + (dx < 0 ? 1 : -1));
          else if (dy > 110 && Math.abs(dy) > Math.abs(dx)) lb.close();
          else { go(idx); }
        }
        g0 = null;
      };
      stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    };
    const open = (i) => {
      if (!lb) build();
      document.documentElement.classList.add('zoomlb-open');
      lb.showModal(); lb._go(i, false);
      const c = $('[data-zl-close]', lb); if (c) c.focus({ preventScroll: true });
    };
    const curSlide = () => { const tr = $('.gallery__track', zGallery); return tr ? Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)) : 0; };
    zImgs.forEach((img, i) => { img.closest('.gallery__slide').addEventListener('click', () => open(i)); });
    if (zBtn) zBtn.addEventListener('click', () => open(clamp(Math.abs(curSlide()), 0, zImgs.length - 1)));
  }

  /* =============== motion polish =============== */
  if (!reduce && fine && !document.body.classList.contains('no-float')) {
    // magnetic primary CTA (one focal element per view)
    $$('.hero .btn').slice(0, 1).forEach((btn) => {
      btn.classList.add('is-magnetic');
      btn.addEventListener('pointermove', (e) => { const r = btn.getBoundingClientRect(); btn.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.25}px, ${(e.clientY - r.top - r.height / 2) * 0.35}px)`; });
      btn.addEventListener('pointerleave', () => { btn.style.transform = ''; });
    });
    // soft 3D tilt + light sheen on product cards
    document.addEventListener('pointermove', (e) => {
      const m = e.target.closest && e.target.closest('.card__media');
      $$('.card__media.is-tilting').forEach((x) => { if (x !== m) { x.classList.remove('is-tilting'); x.style.removeProperty('--rx'); x.style.removeProperty('--ry'); } });
      if (!m) return;
      const r = m.getBoundingClientRect(); const px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      m.classList.add('is-tilting');
      m.style.setProperty('--ry', ((px - 0.5) * 7).toFixed(2) + 'deg'); m.style.setProperty('--rx', ((0.5 - py) * 7).toFixed(2) + 'deg');
      m.style.setProperty('--mx', (px * 100).toFixed(1) + '%'); m.style.setProperty('--my', (py * 100).toFixed(1) + '%');
    }, { passive: true });
  }
  // shared-element morph (card photo -> product page) lives in the page-to-page block at the end of this file
})();

/* ---------- page-to-page image morph (cross-document View Transitions; Chrome/Edge, ignored elsewhere) ----------
   The product photo you tap glides into the product page gallery. CSS names the gallery's first photo
   "pdp-hero"; here we give the tapped card photo the same name just before the old page is captured. */
(() => {
  if (!('onpageswap' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let card = null;
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href*="/products/"]');
    card = a ? a.closest('.card, .pw-card, .sx-prod') : null;
  }, true);
  const clear = () => document.querySelectorAll('[data-vt]').forEach((el) => { el.style.viewTransitionName = ''; el.removeAttribute('data-vt'); });
  window.addEventListener('pageswap', (e) => {
    if (!e.viewTransition) return;
    const to = (e.activation && e.activation.entry && e.activation.entry.url) || '';
    if (!card || !card.isConnected || !/\/products\//.test(to)) { card = null; return; }
    const imgs = Array.from(card.querySelectorAll('img'));
    const img = imgs.find((i) => parseFloat(getComputedStyle(i).opacity) > 0.5) || imgs[0];
    if (!img) return;
    // only one element may carry the name: release the current page's gallery photo first
    document.querySelectorAll('.gallery__slide img').forEach((i) => { i.style.viewTransitionName = 'none'; i.setAttribute('data-vt', ''); });
    img.style.viewTransitionName = 'pdp-hero'; img.setAttribute('data-vt', '');
    card = null;
  });
  window.addEventListener('pageshow', clear);
})();
